import React, { useContext } from "react";
import {
  Stepper,
  Step,
  StepButton,
  StepConnector,
  stepConnectorClasses,
  StepLabel,
} from "@mui/material";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";

import { multiStepContext } from "./ContextApiComponent";

import FirstStep from "./ContactEmailComponent";
import SecondStep from "./InformationDetailComponent";
import ThirdStep from "./PasswordComponent";
import ForthStep from "./CodeComponent";

const theme = createTheme({
  components: {
    MuiStepLabel: {
      styleOverrides: {
        label: {
          fontFamily: "Montserrat",
          fontWeight: 600,
          color: "#8b9bb4",

          "&.Mui-active": {
            color: "#1f2937",
            fontWeight: 700,
          },

          "&.Mui-completed": {
            color: "#1f2937",
            fontWeight: 700,
          },
        },
      },
    },
  },
});

const CustomConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#d8e4f5",
    },
  },

  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#d8e4f5",
    },
  },

  [`& .${stepConnectorClasses.line}`]: {
    borderTopWidth: 2,
    borderColor: "#d8e4f5",
  },
}));

const CustomStepIcon = (props: any) => {
  const { active, completed, icon } = props;

  return (
    <div
      style={{
        width: "30px",
        height: "30px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 500,
        fontSize: "14px",

        backgroundColor: completed
          ? "#36c690"
          : active
          ? "#edfff8"
          : "#ffffff",

        border: active
          ? "2px solid #36c690"
          :completed?"#36c690": "2px solid #d8e4f5",

        color: completed
          ? "#ffffff"
          : "#000000",
      }}
    >
      {icon}
    </div>
  );
};

const StepperForm: React.FC = () => {
  const context = useContext(multiStepContext);

  if (!context) {
    return <div>Error: context is undefined</div>;
  }

  const { currentStep, setCurrentStep } = context;

  const steps = ["Email", "Details", "Password", "Verify"];

  const showStep = (step: number) => {
    switch (step) {
      case 0:
        return <FirstStep />;

      case 1:
        return <SecondStep />;

      case 2:
        return <ThirdStep />;

      case 3:
        return <ForthStep />;

      default:
        return null;
    }
  };

  return (
    <div className="stepper-container" style={{ width: "450px" }}>
      <ThemeProvider theme={theme}>
        <Stepper
          activeStep={currentStep}
          alternativeLabel
          className="stepper"
          connector={<CustomConnector />}
        >
          {steps.map((label, index) => (
            <Step key={label}>
              <StepButton
  onClick={() => {
    if (index <= currentStep) {
      setCurrentStep(index);
    }
  }}
>
  <StepLabel StepIconComponent={CustomStepIcon}>
    {label}
  </StepLabel>
</StepButton>            </Step>
          ))}
        </Stepper>
      </ThemeProvider>

      {showStep(currentStep)}
    </div>
  );
};

export default StepperForm;